/* Change this file to get your personal Portfolio */

// Summary And Greeting Section

import emoji from "react-easy-emoji";

const illustration = {
  animated: true // set to false to use static SVG
};

const greeting = {
  username: "Harshit Shah",
  title: "Hi all, I'm Harshit",
  subTitle: emoji(
    "A passionate Full Stack QA Automation 🚀 having wide experience in designing and building Web & API Automation Framework using Java/Python and some other cool libraries and frameworks."
  ),
  resumeLink:
    "https://drive.google.com/file/d/1ofFdKF_mqscH8WvXkSObnVvC9kK7Ldlu/view?usp=sharing",
  displayGreeting: true // Set false to hide this section, defaults to true
};

// Social Media Links

const socialMediaLinks = {
  github: "https://github.com/Harshitautomation",
  linkedin: "https://in.linkedin.com/in/harshitshah15",
  gmail: "harshitshah156@gmail.com",
  // gitlab: "https://gitlab.com/",
  // facebook: "https://www.facebook.com/",
  //medium: "https://medium.com/@davidrakosi",
  // stackoverflow: "https://stackoverflow.com/users/13263979/drakosi",
  //instagram: 'https://www.instagram.com/davidrakosi/',
  //twitter: 'https://twitter.com/davidrakosi_',
  display: true // Set true to display this section, defaults to false
};

// Skills Section

const skillsSection = {
  title: "What I do",
  subTitle: "FULL STACK QA Engineer who want to explore different framework and integrate it with cloud",
  skills: [
    emoji(
      "⚡ Devloping Automation Framework for WEB & API and learning on Mobile Automation using different Tools"
    ),
    emoji(
      "⚡ Integrate Test Automation with DevOps world using Docker/AWS/Ansible/Terraform"
    )
  ],

  /* Make Sure to include correct Font Awesome Classname to view your icon
https://fontawesome.com/icons?d=gallery */

  softwareSkills: [
    {
      skillName: "Selenium",
      fontAwesomeClassname: "fab fa-Selenium"
    },
    {
      skillName: "Java",
      fontAwesomeClassname: "fab fa-java"
    },
    {
      skillName: "API Testing",
      fontAwesomeClassname: "fab fa-APITEsting" 
    },
    {
      skillName: "Cucumber",
      fontAwesomeClassname: "fab fa-Cucumber"
    },
    
  ],
  display: true // Set false to hide this section, defaults to true
};

// Education Section

const educationInfo = {
  display: true, // Set false to hide this section, defaults to true
  schools: [
    {
      schoolName: "Sardar Vallabhbhai Institute of Technology",
      logo: require("./assets/images/svit.png"),
      subHeader: "Bachelor in Electronics & Communication",
      duration: "July 2009 - June 2013",
    //  desc: "Involved in Organizing Tech Fest Event. ",
    //  descBullets: [
    //    "Lorem ipsum dolor sit amet, consectetur adipiscing elit"
    //  ]
    }
   /* {
      schoolName: "Stanford University",
      logo: require("./assets/images/stanfordLogo.png"),
      subHeader: "Bachelor of Science in Computer Science",
      duration: "September 2013 - April 2017",
      desc:
        "Ranked top 10% in the program. Took courses about Software Engineering, Web Security, Operating Systems, ...",
      descBullets: ["Lorem ipsum dolor sit amet, consectetur adipiscing elit"]
    } */
  ]
};

// Your top 3 proficient stacks/tech experience

const techStack = {
  viewSkillBars: true, //Set it to true to show Proficiency Section
  experience: [
    {
      Stack: "Selenium with Java", //Insert stack or technology you have experience in
      progressPercentage: "85%" //Insert relative proficiency in percentage
    },
    {
      Stack: "Cucumber(BDD)",
      progressPercentage: "75%"
    },
    {
      Stack: "API Testing",
      progressPercentage: "70%"
    },
    {
      Stack: "Agile Methodology",
      progressPercentage: "70%"
    },
    {
      Stack: "GIT/MAVEN/JENKINS",
      progressPercentage: "60%"
    }
  ],
  displayCodersrank: true // Set true to display codersrank badges section need to changes your username in src/containers/skillProgress/skillProgress.js:17:62, defaults to false
};

// Work experience section

const workExperiences = {
  display: true, //Set it to true to show workExperiences Section
  experience: [
    {
      role: "Sr.QA Automation Engineer",
      company: "HSBC",
      companylogo: require("./assets/images/HSBC.png"),
      date: "January 2020 – Present",
      desc:
        "Creating Automation Framewrok from Scratch using Intellij,Java,Selenium,Cucumber",
      descBullets: [
        "Working on CI Environment using GIT,Jenkins,Docker & Maven",
        "Involved in API Testing using Rest-Assured/Postman",
        "Involved in Mocking of service using Wiremock for Testing",
        "Working in Scrum as an individual Contributor",
        "Involved in creation of Test Estimation, Test Deliverables,Project Planning"
      ]
    },
    {
      role: "Sr.Software Engineer",
      company: "Tech Mahindra Ltd",
      companylogo: require("./assets/images/techm.png"),
      date: "September 2013 – December 2019",
      desc:
        "Leading a Team of 5 Member for Testing an Application of a Leading Telecom Provider",
        descBullets: [
          "Worked at Client location in Atlanta(USA) for 18 Months.",
          "Involved in testing of Billing Payment for Telecom Provider"
        ]  
    },
  ]
};

/* Your Open Source Section to View Your Github Pinned Projects
To know how to get github key look at readme.md */

const openSource = {
  githubConvertedToken: process.env.REACT_APP_GITHUB_TOKEN,
  githubUserName: "Harshitautomation", // Change to your github username to view your profile in Contact Section.
  showGithubProfile: "true", // Set true or false to show Contact profile using Github, defaults to true
  display: false // Set false to hide this section, defaults to true
};

// Some big projects you have worked on

const bigProjects = {
  title: "Big Projects",
  subtitle: "SOME STARTUPS AND COMPANIES THAT I HELPED TO CREATE THEIR TECH",
  projects: [
    {
      image: require("./assets/images/saayaHealthLogo.webp"),
      projectName: "Saayahealth",
      projectDesc: "Lorem ipsum dolor sit amet, consectetur adipiscing elit",
      footerLink: [
        {
          name: "Visit Website",
          url: "fa"
        }
        //  you can add extra buttons here.
      ]
    },
    {
      image: require("./assets/images/nextuLogo.webp"),
      projectName: "Nextu",
      projectDesc: "Lorem ipsum dolor sit amet, consectetur adipiscing elit",
      footerLink: [
        {
          name: "Visit Website",
          url: ""
        }
      ]
    }
  ],
  display: false // Set false to hide this section, defaults to true
};

// Achievement Section
// Include certificates, talks etc

const achievementSection = {
  title: emoji("Achievements And Certifications 🏆 "),
  subtitle:
    "Achievements, Certifications, Award Letters and Some Cool Stuff that I have done !",

  achievementsCards: [
    {
      title: "AWS Solution Architect Associate Certified",
      image: require("./assets/images/aws.png"),
      footerLink: [
        {
          name: "Certification",
          Expires: "April 2024",
        }
      ]
    },
    {
      title: "Oracle CLoud Infrastructure Associate",
      image: require("./assets/images/oracle.png"),
      footerLink: [
        {
          name: "Certification",
        }
      ]
    },

  /*  {
      title: "PWA Web App Developer",
      subtitle: "Completed Certifcation from SMIT for PWA Web App Development",
      image: require("./assets/images/pwaLogo.webp"),
      footerLink: [
        {name: "Certification", url: ""},
        {
          name: "Final Project",
          url: ""
        }
      ]
    } */
  ],
  display: true // Set false to hide this section, defaults to true
};

// Blogs Section

const blogSection = {
  title: "Blogs",
  subtitle:
    "With Love for Developing cool stuff, I love to write and teach others what I have learnt.",

  blogs: [
    {
      url:
        "https://blog.usejournal.com/create-a-google-assistant-action-and-win-a-google-t-shirt-and-cloud-credits-4a8d86d76eae",
      title: "Win a Google Assistant Tshirt and $200 in Google Cloud Credits",
      description:
        "Do you want to win $200 and Google Assistant Tshirt by creating a Google Assistant Action in less then 30 min?"
    },
    {
      url: "https://medium.com/@saadpasta/why-react-is-the-best-5a97563f423e",
      title: "Why REACT is The Best?",
      description:
        "React is a JavaScript library for building User Interface. It is maintained by Facebook and a community of individual developers and companies."
    }
  ],
  display: false // Set false to hide this section, defaults to true
};

// Talks Sections

const talkSection = {
  title: "TALKS",
  subtitle: emoji(
    ""
  ),

  talks: [
    {
      title: "",
      subtitle: "",
      slides_url: "",
      event_url: ""
    }
  ],
  display: false // Set false to hide this section, defaults to true
};

// Podcast Section

const podcastSection = {
  title: emoji("Podcast 🎙️"),
  subtitle: "I LOVE TO TALK ABOUT MYSELF AND TECHNOLOGY",

  // Please Provide with Your Podcast embeded Link
  podcast: [
    ""
  ],
  display: false // Set false to hide this section, defaults to true
};

const contactInfo = {
  title: emoji("Contact Me ☎️"),
  subtitle:
    "Discuss a project or just want to say hi? My Inbox is open for all.",
  //number: "(323) 768 0674",
  email_address: "harshitshah156@gmail.com"
};

// Twitter Section

const twitterDetails = {
  userName: "davidrakosi_", //Replace "twitter" with your twitter username without @
  display: false // Set true to display this section, defaults to false
};

export {
  illustration,
  greeting,
  socialMediaLinks,
  skillsSection,
  educationInfo,
  techStack,
  workExperiences,
  openSource,
  bigProjects,
  achievementSection,
  blogSection,
  talkSection,
  podcastSection,
  contactInfo,
  twitterDetails
};
